<template lang='pug'>
  v-card
    v-card-title.dialog-card-title
      p {{$t('transfers.do_transfer')}}
      v-icon(color="white" aria-label="Close" @click='cancel') mdi-close
    v-card-text.mt-2
      v-form
        v-container(pa-0='')
          v-layout(wrap='')
            v-flex(xs12='', md12='')
              v-snackbar(v-model='snackbar',  :color='color', center top  :timeout="6000")
                | {{ message }}
                v-btn(dark='', text='', @click='snackbar = false')
                  | Close
              v-row
                v-col(cols="12" md="6")
                  v-autocomplete(style='min-width: 200px;' v-model='model.location_from', return-object :items='locations', item-text="name" dense='', filled='', label='Punto de partida')
                v-col(cols="12" md="6")
                  v-autocomplete(style='min-width: 200px;' v-model='model.location_to', return-object :items='locations', item-text="name" dense='', filled='', label='Destino')
              v-layout.column
                v-layout
                v-col(cols="12").pl-0
                  v-btn.mx-2(small dark color='indigo' @click="itemsDialog = !itemsDialog" block) Seleccionar Productos
                  //- Seleccionar productos
                  v-dialog(v-model="itemsDialog" width="500")
                    v-card
                      v-card-title.dialog-card-title
                        p Selecciona varios productos
                        v-icon(color="white" @click='itemsDialog = false') mdi-close
                      v-card-text
                        v-autocomplete(@change="addProduct(item)" v-model="selectedProducts" :items="inventory" filled="" chips="" color="blue-grey lighten-2" label="Selecciona multiples productos" item-text="name" multiple="" return-object)
                          template(v-slot:selection="data")
                            v-chip(:input-value="data.name" close="" @click="data.select" @click:close="deleteChip(data)")
                              v-avatar(left="")
                                v-img(:src="getImage(data.item.pictures.imageInput1)")
                              | {{ data.item.name }}
                          template(v-slot:item="data")
                            template
                              v-list-item-avatar
                                img(:src="getImage(data.item.pictures.imageInput1)")
                              v-list-item-content
                                v-list-item-title(v-html="data.item.name").product-list__title
                        v-btn(color="primary" @click="selectItems" block) Aceptar
                v-flex.mt-4.column( style="max-height: 300px; overflow-y: auto;")
                  v-flex.purchase-form__input(style='display:flex; ' v-for="(item, index) in model.items" )
                    v-autocomplete(@change ='handleItemSelect(item, item.name)' style='min-width: 200px;' v-model='item.name', :disabled="!model.location_from" , :items='inventory', item-text="name" dense='', filled='', label='Nombre del producto')
                    v-text-field( label='Cantidad a mover' :rules='[rules.required, rules.twoDecimals, rules.numberRule]'  type="text" @input="replaceComma(item)" v-model='item.amount' :disabled="!model.location_from")
                    v-text-field( readonly :label='remainingLabel' min='0' type="number", :value="getRemaining(item)")
                    v-btn.ml-4(icon text color='danger', @click='deleteRow(index)' )
                      | x
              .text-center
                v-btn(@click='cancel') Cancelar
                v-btn(color='#008e95', @click='save' :loading="isLoading" :disabled='isLoading || model.items.length === 0' ) GUARDAR
</template>
<script>
  import Preview from '../preview/ProductPreview'
  import loaders from '../../../plugins/mixins/loaders'
  import productPlaceHolder from '@/assets/icons/products.png'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    components: {
      Preview: Preview,

    },
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },

    },
    mixins: [loaders],

    data () {
      return {
        productPlaceHolder,
        selectedProducts: [],
        itemsDialog: false,
        rules: {
          required: value => !!value || 'Ingresar la cantidad',
          twoDecimals: value => /^[0-9]+(\.[0-9]{1,2})?$/.test(value) || 'Maximo dos decimales',
          numberRule: v => (!isNaN(parseFloat(v)) && v >= 0) || 'La cantidad debe ser mayor que 0',
        },
        message: '',
        snackbar: false,
        color: 'success',
        isLoading: false,
        rows: 1,
        model: {
          location_from: '',
          location_to: '',
          items: [],
        },
        valueType: '',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        imageLoading: false,
        audioLoading: false,
        toggle_exclusive: 2,
      }
    },
    computed: {
      inventory () {
        const vm = this
        try {
          let products = vm.$store.state.products.product_list
          if (products) {
            products = products.filter(function (el) {
              if (vm.model.location_from.id && el.location) {
                if (el.location[vm.model.location_from.id]) {
                  // console.log(el)
                  return el.location[vm.model.location_from.id].stock > 0 && el.type !== 'service' && el.type !== 'bundle'
                }
              }
            })
            products.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : -1)
            return products
          } else return []
        } catch (err) {
          // console.log(err)
          return []
        }
      },
      locations () {
        return this.$store.state.shops.shops_list
      },
      remainingLabel () {
        return 'Restantes en ' + this.model.location_from.name
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    watch: {
      // isLoading (newVal, oldVal) {
      //   const vm = this
      //   if (!newVal) {
      //     vm.message = 'Traslado registrado correctamente!'
      //     vm.snackbar = true
      //     vm.color = 'success'
      //     vm.reset()
      //   }
      // },
    },
    mounted () {
      // this.onResize()

      /* if (!this.inventory.length) {
        this.loadProducts()
      } */
      if (!this.locations.length) {
        this.loadLocations()
      }
    },
    methods: {
      deleteChip (ingredient) {
        const vm = this
        vm.selectedProducts.splice(ingredient.index, 1)
      },
      replaceComma (item) {
        if (typeof item.amount === 'string') {
          item.amount = parseFloat(item.amount.replace(',', '.'))
        }
        return item.amount
      },
      getRemaining (product) {
        const vm = this
        try {
          const currentItem = vm.inventory.find(item => item.name === product.name)
          if (currentItem) {
            return currentItem.location[vm.model.location_from.id].stock - product.amount
          } else return ''
        } catch (err) {
          // console.log(err)
          return null
        }
      },
      handleItemSelect (selected, name) {
        const currentItem = this.inventory.find(item => item.name === name)
        if (currentItem) {
          selected.id = currentItem.id
          selected.name = currentItem.name
          selected.pictures = currentItem.pictures
          selected.magnitude = currentItem.magnitude || 0
          selected.unit = currentItem.unit || ''
          selected.statusOrigin = 'pending'
          selected.statusDestiny = 'pending'
        }
      },
      loadLocations () {
        const vm = this
        // vm.$store.commit('setLoading',true);
        vm.$store.dispatch('shops/loadItems', 'shops').then(() => {

        })
      },
      deleteRow (index) {
        this.model.items.splice(index, 1)
      },
      addRows () {
        this.model.items.push(
          {
            name: '',
            amount: '',
            pictures: {
              imageInput1: '',
            },
          },
        )
      },
      getCartTotal (list) {
        let total = 0
        list.forEach(function (item) {
          total = total + parseInt(item.amount * item.price)
        })
        return total
      },
      reset () {
        const vm = this
        vm.selectedProducts = []
        vm.model = {
          location_from: '',
          location_to: '',
          items: [],
        }
      },
      cancel () {
        this.reset()
        this.$emit('close')
      },
      save () {
        const vm = this
        vm.isLoading = true
        let valid = true
        if (!vm.model.location_to) {
          valid = false
          vm.message = 'Debes seleccionar un destino'
          vm.snackbar = true
          vm.color = 'red'
        }
        if (vm.model.location_to.id === vm.model.location_from.id) {
          valid = false
          vm.message = 'El origen debe ser diferente al destino'
          vm.snackbar = true
          vm.color = 'red'
        }
        vm.model.items.forEach(function (item, index) {
          if (item.name === '' || item.amount === '' || item.amount <= 0 || vm.getRemaining(item) < 0) {
            vm.message = `Verifica la informacion del producto # ${index + 1}`
            vm.snackbar = true
            vm.color = 'red'
            // console.log(vm.message)
            valid = false
          }
        })
        const transaction = {
          type: 'transfers',
          items: vm.model.items,
          location_from: vm.model.location_from,
          location_to: vm.model.location_to,
          time: vm.$moment().format(),
        }

        if (valid) {
          // console.log('envio valido')
          vm.$store.dispatch('transactions/sendBill', transaction).then(function () {
            vm.isLoading = false
            vm.$swal({
              icon: 'success',
              title: 'Traslado exitoso',
              text: '¿Desea agregar otro traslado?',
              showCancelButton: true,
              confirmButtonText: 'Si',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.value) {
                vm.reset()
              } else {
                vm.$emit('close')
              }
            })
          })
        } else {
          vm.isLoading = false
        }
      },
      getImage (url) {
        if (url === '') {
          return productPlaceHolder
        } else {
          return url
        }
      },
      selectItems () {
        const vm = this
        vm.model.items = []
        for (let index = 1; index < vm.selectedProducts.length + 1; index++) {
          vm.addRows()
          vm.handleItemSelect(vm.model.items[index - 1], vm.selectedProducts[index - 1].name)
        }
        vm.itemsDialog = false
      },
    },

  }
</script>
<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;

  .purchase-form{
    &__input{
      flex-wrap: wrap;
      @media screen and (min-width: $break-large) {
        flex-wrap: nowrap;
      }
    }
  }

  .grid-picker{
    text-align: center;
    min-width: 100%;
    display: grid;
    position: relative;
    flex: 1;
    width: 100%;
    grid-template-areas:

      'picture picture '
      'title title '
      'button button';
    @media screen and (min-width: $break-large) {
      grid-template-areas:

        'title picture picture '
        'title picture picture '
        'button button button';
      .image-slot{
        min-width: 400px;
        height: 250px;
        overflow: hidden;
      }
    }

    grid-gap: 10px;

    padding: 10px;
    .picker-btn{

      grid-area: button;
      flex: 1;
      height: 50px;
    }
    .image-slot{
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      display: flex;
      grid-area: picture;
      max-width: 350px;
      max-height: 250px;
      background: #9e9e9e;
      align-items:center;
      justify-content: center;

    }
  }

  .phone-screen{

    background: url("/img/phone.png");
    display:flex;
    flex-direction: column;
    border-radius: 50px;
    border: 1px solid black;

    min-width: 379px;
    min-height: 736px;
    background-size:  379px 736px;
    background-repeat: no-repeat;
    margin:auto;
    overflow: hidden;
    &__content{

      overflow-y: auto;
      max-width: 382px;
      max-height: 595px;
      margin: auto !important;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 15px;
    }
  }
  .main-carousel{
    position: relative;
    &__overlay{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      height: 45px;
      width: 100%;
      margin: auto !important;
      background:rgba(#000,0.5);
      color: #fff;
      text-align: center;

    }
  }
  .property-values{
    border: 1px solid #c29f52;
    border-radius: 30px;
    height: auto;
    padding: 0 10px;
    h3{
      color:#c29f52;
      font-weight: 900;

    }
    .price-tooltip{
      color:#c29f52;
      font-weight: bold;
      margin:auto;
      margin-top:-10px;
      max-width: 100px;
      border: 1px solid #c29f52;
      border-radius: 15px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top: none;
    }
  }
  .numPayments{
    background: white !important;
    border: 1px solid #777;
    border-radius: 25px;
    width:auto;
    max-width: fit-content;

    &__button{
      color:#000 !important;
      border-radius: 40px;
    }
  }
  .v-input--slider{
    margin-top:0;
  }
  .v-tabs__container{
    max-width: 100%;
    overflow-x: auto;

  }
  .property-sections{
    span,b{
      font-size: 15px !important;
    }

    .v-tab{
      color: black !important;
    }
  }
  .property-toolbar{

  }

  .product-list__title {
    max-width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
